import axios from '../axios';
import { PREFIX, VERSION } from '../enums/request';
import { ResetPasswordRequestData, SaveNewPasswordData, SignInCredentials, ValidateCodeData } from '../interfaces';

export default class AuthResource {
  static login(data: SignInCredentials) {
    return axios.post(`/${PREFIX.PARTNERS}/${VERSION.V2}/login`, data);
  }

  static postResetPassword(data: ResetPasswordRequestData) {
    return axios.post(`/${PREFIX.PARTNERS}/${VERSION.V2}/login/password`, data);
  }

  static getValidatePasswordResetLink(emailHash: string, pwdHash: string) {
    return axios.get(`/${PREFIX.PARTNERS}/${VERSION.V2}/login/${emailHash}/${pwdHash}`);
  }

  static getValidateCodeIsValid(data: ValidateCodeData) {
    return axios.post(`/${PREFIX.PARTNERS}/${VERSION.V2}/login/otp`, data);
  }

  static putSaveNewPassword(data: SaveNewPasswordData) {
    return axios.put(`/${PREFIX.PARTNERS}/${VERSION.V2}/login/password`, data);
  }
}
